import React, {useState,useEffect} from 'react';
import {Formulario, Input, Etiqueta, ContenedorBoton} from '../elementos/ElementosDeFormulario'
import Boton from '../elementos/Boton'
import Api from '../servicios/api';
import Alerta from '../elementos/Alerta'
import { useNavigate } from "react-router-dom";


const FormularioUbicacion = ({ubicacion}) => {
    const [inputLugar, setInputLugar] = useState('');
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const navigate = useNavigate();

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        if(ubicacion){
            setInputLugar(ubicacion.Ubi_Nombre);
        }
    }, [ubicacion]);

    const handleChange = (e) => {
        switch(e.target.name){
            case 'lugar':
                setInputLugar(e.target.value);
                break;
            default:
                break;
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setEstadoAlerta(false);
        setAlerta({});

        // Validaciones del lado del cliente para que los inputs no esten vacios
        if(inputLugar === ''){
            setEstadoAlerta(true);
            setAlerta({
                tipo: 'error',
                mensaje: 'Por favor rellena todos los datos'
            });
            return;
        }

        var datosEnviar;
        if(!ubicacion){
            datosEnviar = {lugar:inputLugar}
            
            fetch(Api+"?insertarUbicacion=1",{
                method:"POST",
                body:JSON.stringify(datosEnviar)
            })
            .then(respuesta=>respuesta.json())
            .then((datosRespuesta)=>{
                setInputLugar('');
                setEstadoAlerta(true);
                setAlerta({
                    tipo: 'exito',
                    mensaje: 'Ubicación registrada correctamente.'
                });
            })
            .catch(console.log)
        }

        else{
            datosEnviar = {id:ubicacion.Ubi_ID, lugar:inputLugar}

            fetch(Api+"?actualizarUbicacion=1",{
                method:"POST",
                body:JSON.stringify(datosEnviar)
            })
            .then(respuesta=>respuesta.json())
            .then((datosRespuesta)=>{
                navigate("/ubicacion");
            })
            .catch(console.log)
        }
    }

    return (
        <>
            <Formulario onSubmit={handleSubmit}>
                <div>
                    <Etiqueta htmlFor="">Nombre</Etiqueta>
                    <Input
                        type="text"
                        name="lugar"
                        placeholder="Lugar de Ubicación"
                        value={inputLugar}
                        onChange={handleChange}
                    />
                </div>

                <ContenedorBoton>
                        <Boton to="/ubicacion">Cancelar</Boton>
                        <Boton as="button" type="submit" primario="true">
                            {ubicacion ? 'Actualizar' : 'Guardar'} 
                        </Boton>
                </ContenedorBoton>
            </Formulario>

            <Alerta 
                tipo={alerta.tipo}
                mensaje={alerta.mensaje}
                estadoAlerta={estadoAlerta}
                setEstadoAlerta={setEstadoAlerta}
            />
        </>
    );
}
 
export default FormularioUbicacion;